export function initShowMore(btnSelector, itemSelector) {
    const btn = document.querySelector(btnSelector);
    
    if (!btn) return;

    btn.addEventListener('click', (e) => {
        e.preventDefault();

        const hiddenItems = document.querySelectorAll(itemSelector);
        
        hiddenItems.forEach(item => {

            item.classList.remove('hidden');
            item.classList.add('flex');
        });


        btn.classList.add('hidden'); 
    });
}